import PageHeader from 'src/components/organisms/PageHeader';
import Footer from 'src/components/molecules/footer/Footer';
import ContentCardsContainer, { CardType, ContentCard } from 'src/components/organisms/ContentCard';
import { CustomDataGrid } from 'src/components/organisms/CustomDataGrid';
import { generateTablePageButtons } from 'src/utils/generateTablePageButtons';
import { useFullfillmentOrderRowsTable, useFullfillmentOrdersTable } from 'src/hooks/table/configs/useFullfillmentOrdersTable';
import DetailPanelContainer from 'src/components/organisms/tables/DetailPanelContainer';
import CustomButton from 'src/components/atoms/buttons/CustomButton';
import { Grid } from '@mui/material';
import useRequest from 'src/hooks/api/useRequest';
import { dispatchFullfillmentOrder } from 'src/utils/apiRequests';

export const FullfillmentOrders = () => {
    const [columns, tableSettings] = useFullfillmentOrdersTable();
    return (
        <>
            <PageHeader  {...{
                title: "Fullfillment Orders ",
                subTitle: "Track Orders, their products and from what Warehouse the products are shipped",
                components: [
                    ...generateTablePageButtons(tableSettings),
                ]
            }} />
            <ContentCardsContainer >
                <ContentCard {...{ cardTypes: [CardType.noHeader], contentPadding: 0 }}>
                    <CustomDataGrid columns={columns} tableSettings={tableSettings} getDetailPanelContent={(row) => <DetailPanelContent {...{ row }} />} />
                </ContentCard>
            </ContentCardsContainer>


            <Footer />
        </>
    );
}
export default FullfillmentOrders;

const DetailPanelContent = ({ row }) => {
    const [result,setRequest] = useRequest({logLevel:["error","success"]});
    const [columns, tableSettings, createdDispatchCommandId] = useFullfillmentOrderRowsTable(row?.id, result);
    
//console.log(row, createdDispatchCommandId);

    const dispatchOrder = () => {
        setRequest(dispatchFullfillmentOrder(row?.id, createdDispatchCommandId));
    }
    return (
        <>
            <Grid container spacing={2} >
                <Grid item md={2} marginLeft={2} marginTop={1} >
                    <CustomButton disabled={createdDispatchCommandId == undefined} title="Dispatch Order Manually" // iconButton={true} icon={<LocalShippingIcon/>}
                        onClick={dispatchOrder} />
                </Grid>
            </Grid>

            <DetailPanelContainer>
                <CustomDataGrid columns={columns} tableSettings={tableSettings} ></CustomDataGrid>
            </DetailPanelContainer>
        </>

    );
}

